export default __webpack_public_path__ + "static/WorkSans-SemiBold-3adf8db307631f1a074f64bb70a8f236.woff2";